import {find as _find} from 'lodash';
import {ButtonSwitch, ButtonSwitchOption} from '@gisatcz/ptr-atoms';
import PropTypes from 'prop-types';
import {
	IntervalsLine,
	Legend,
	LegendHeader,
	ValuesByColor,
} from '../../../atoms/Legend';
import {SpecificAttributeLegend} from '../../../specific/Legends';

import './style.scss';

const LayerSwitch = ({styles, activeKey, onStyleChange}) => {
	const content = styles.map(style => (
		<ButtonSwitchOption
			key={style?.key}
			value={style?.key}
			active={style?.key === activeKey}
		>
			{style?.data?.nameDisplay}
		</ButtonSwitchOption>
	));

	content.push(
		<ButtonSwitchOption key="none" value={null} active={!activeKey}>
			None
		</ButtonSwitchOption>
	);

	return (
		<ButtonSwitch onClick={onStyleChange} ghost>
			{content}
		</ButtonSwitch>
	);
};

LayerSwitch.propTypes = {
	styles: PropTypes.array,
	activeKey: PropTypes.string,
	onStyleChange: PropTypes.func,
};

const LayerLegendContent = ({data, noDataColor}) => {
	const {attributeClasses, attributeValues} = data;

	if (attributeClasses) {
		return (
			<IntervalsLine
				styleProperty="fill"
				classes={attributeClasses}
				noData={noDataColor}
				longerTails
			/>
		);
	} else if (attributeValues) {
		return <ValuesByColor data={attributeValues} noData={noDataColor} />;
	} else {
		return null;
	}
};

LayerLegendContent.propTypes = {
	data: PropTypes.object,
	noDataColor: PropTypes.string,
};

const LayerLegend = ({styles, activeKey}) => {
	const style = _find(styles, style => style.key === activeKey);

	if (style) {
		const styleDefinitions = style.data?.definition?.rules?.[0]?.styles;

		const baseStyle = styleDefinitions[0];
		const attributeStyle = styleDefinitions[1];
		const secondAttributeStyle = styleDefinitions[2];
		const noDataColor = baseStyle.fill;

		if (attributeStyle) {
			// eslint-disable-next-line no-unused-vars
			const {attributeKey, ...attributeDefinitions} = attributeStyle;

			let title = style.data.nameInternal || style.data.nameDisplay;
			let subtitle = style.data.description;

			return (
				<>
					<Legend>
						<LegendHeader title={title} subtitle={subtitle} />
						<LayerLegendContent
							data={attributeDefinitions}
							noDataColor={noDataColor}
						/>
					</Legend>
					{secondAttributeStyle ? (
						<SpecificAttributeLegend
							attributeKey={secondAttributeStyle.attributeKey}
						/>
					) : null}
				</>
			);
		} else {
			return null;
		}
	} else {
		return null;
	}
};

LayerLegend.propTypes = {
	styles: PropTypes.array,
	activeKey: PropTypes.string,
};

const LayerSwitcher = ({
	activeStyleKey,
	availableStyleKeys,
	styles,
	handleLayer,
}) => {
	const availableStyles = availableStyleKeys?.map(key => styles[key]);

	return (
		<div className="insar-LayerSwitcher">
			<LayerSwitch
				styles={availableStyles}
				activeKey={activeStyleKey}
				onStyleChange={handleLayer}
			/>
			<LayerLegend styles={availableStyles} activeKey={activeStyleKey} />
		</div>
	);
};

LayerSwitcher.propTypes = {
	activeStyleKey: PropTypes.string,
	availableStyleKeys: PropTypes.array,
	layerKey: PropTypes.string,
	styles: PropTypes.object,
	handleLayer: PropTypes.func,
};

export default LayerSwitcher;
